<template>
  <table class="tableDettaglio mr-3">
    <tr>
      <th
        v-for="(header,i) in headers"
        :style="{width: + header.width + 'px', textAlign: header.align}"
        :key="i"
      >
        <span v-html="header.text"></span>
      </th>
    </tr>
    <tr
      v-for="(item,z) in dati"
      :key="z"
    >
      <td
        v-for="(header,x) in headers"
        :style="header.style"
        :key="x"
      >
        <img
          v-if="header.dataType=='Image'"
          :src="getImg(item[header.value], header.imageConditions)"
          style="padding-top:5px;"
        >

        <span
          v-else
          v-text="formatValue(item[header.value], header.dataType)"
        ></span>
      </td>
    </tr>
  </table>
</template>


<script>
import mixin from "@/mixin/mixinTable.js";

export default {
  mixins: [mixin],

  props: {
    headers: {
      type: Array,
      default: function() {
        return [];
      }
    },
    dati: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },

  methods: {}
};
</script>


<style scoped>
table.v-table {
  table-layout: fixed;
}

/* ---------------------- */
/*   Tabella dettaglio    */
/* ---------------------- */
table.tableDettaglio {
  table-layout: fixed;
  border-spacing: 0px;
  margin-bottom: 30px;
  background-color: #eee;
  /*border: 1px solid #6B6B6B;*/
  box-shadow: 5px 5px 5px 0px grey;
  font-size: 12px;
}
table.tableDettaglio th {
  height: 30px !important;
  /*border-bottom: 1px solid;*/
  text-align: left;
  background-color: #ddd;
}
table.tableDettaglio th:first-child,
th:not(:first-child),
td:first-child,
td:not(:first-child) {
  padding: 0px !important;
}

table.tableDettaglio td:first-child {
  border-left: 1px solid lightgray;
}

table.tableDettaglio td {
  height: 30px !important;
  font-weight: bold;
  color: black;
  border-bottom: 1px solid lightgray;
}
/* ---------------------- */
</style>
